import styled from "styled-components";
import colors from "./colors.tsx";

export const MainContainer = styled.main`
    padding-left: 10%;
    padding-right: 10%;
`

export const CenterTitle = styled.div`
    text-align: center;
`

export const Title = styled.h1`
    font-weight: 100;
    color: ${colors.h1_red};
    font-size: 50px;

    @media (max-width: 768px) {
        font-size: 24px;
    }
`

export const CardBackground = styled.div`
    position: relative;
    background-color: ${colors.light_pink};
    border: solid 5px ${colors.black};
    border-radius: 60px;
    padding: 35px;

    &::before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        border-radius: 60px;
        background-color: ${colors.black};
        z-index: -1;
        box-shadow: 11px 11px ${colors.black};
    }
`


export const CardBackgroundTitle = styled.h1`
    font-family: "Archivo Black",sans-serif;
    text-align: left;
    color: #FFFFFF;
    font-weight: 900;
    margin: 0;
    text-shadow: 4px 4px #512828;
    -webkit-text-stroke-color: #512828;
    line-height: normal;
    font-size: 50px;
    -webkit-text-stroke-width: 2px;
    transform: none;
`

export const CardBackgroundTextWrapper = styled.div`
    display: flex;
    margin-top: 3%;
`


export const CardBackgroundText = styled.p`
    font-family: "Archivo",sans-serif;
    text-align: left;
    color: ${colors.black};
    font-weight: 400;
    margin: 0;
    font-size: 20px;
    height: fit-content;
    line-height: 35px;
    width: 70%;
`


export const CardBackgroundImageWrapper = styled.div`
    display: flex;
    padding-left: 20px;
    align-items: center;
`

export const CardBackgroundImage = styled.img`
    width: 100%;
    object-fit: contain;
`
